import React from 'react'

import { colors } from 'Constants'

import ReportHeader from '../../components/ReportHeader'
import ArchiveReport from './ArchiveReport'
import Section from 'Components/Section'

export default ({ report, reasons }) => {
  const columnReasons = reasons.map(item => {
    return { header: item.reason_text, property: item.reason_text }
  })

  const allColumnReasons = [
    { header: 'No reason', property: 'No reason' },
    ...columnReasons
  ]

  const cardValues = Object.keys(report.totalArchivedTcodesBreakdown).reduce(
    (acc, item) => {
      const cardItem = [
        'Total',
        item,
        report.totalArchivedTcodesBreakdown[item]
      ]
      acc.push(cardItem)
      return acc
    },
    []
  )

  return (
    <>
      <ReportHeader
        header="Office"
        title={report.title}
        cardValues={cardValues}
      />
      <Section header="Journey Name" title={report.journeyName} />
      {Object.values(report.archivedTcodesByDoctor).length === 0 && (
        <div
          style={{
            textAlign: 'center',
            padding: '16px 0',
            margin: '16px 0',
            borderBottom: `1px solid ${colors.borderColor}`
          }}
        >
          There are no items in this office
        </div>
      )}
      {Object.keys(report.archivedTcodesByDoctor).map(initials => (
        <>
          <ArchiveReport
            archiveItems={report.archivedTcodesByDoctor[initials]}
            initials={initials}
            columnReasons={allColumnReasons}
            archiveItemsBreakdown={
              report.archivedTcodesByDoctorBreakdown[initials]
            }
          />
          <hr
            style={{
              width: '100%',
              border: `1px solid ${colors.borderColor}`
            }}
          />
        </>
      ))}
    </>
  )
}
